













import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {ExportType} from '@payroll/grid-widget/src/models/ExportType'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {BaseRequest} from '@payroll/optimus-common'
import {Component, Prop} from 'vue-property-decorator'
import {Action} from 'vuex-class'

@Component
export default class PolicyDetailsTab extends AfterFetchComponent {

  @Action('getAccountDetails', StoreNamespace.CUSTOMER_SERVICE) getAccountDetails: any
  @Action('exportAccountDetails', StoreNamespace.CUSTOMER_SERVICE) exportAccountDetails: any

  @Prop() memberIdNum!: string

  private columns: GridColumn[] = []

        beforeMount() {
            this.hasFeedback = true
        }

        mounted() {
            this.initColumns();
            this.getAccountDetails({
                pathVariable: this.memberIdNum,
                requestorCallback: this
            })
        }

        onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
            if (requestName === 'getAccountDetails') {
                this.$emit('successResults', data)
            } else {
                this.$emit('successExport', data)
            }
        }

        private initColumns(): void {
            this.columns.push({property: 'accountStatus', header: 'status_policy', widthInPoints: 80})
            this.columns.push({property: 'accountNum', header: 'policy_number', widthInPoints: 80})
            this.columns.push({
                property: 'totalCompensations',
                header: 'total_compensations',
                widthInPoints: 80,
                pattern: '₪ #,##0.00;₪ -#,##0.00'
            })
            this.columns.push({
                property: 'depositFeePercentage',
                header: 'deposit_fee_percentage',
                widthInPoints: 50,
                isPercent: true
            })
            this.columns.push({
                property: 'accumulatedFeePercentage',
                header: 'accumulated_fee_percentage',
                widthInPoints: 50,
                isPercent: true
            })
            this.columns.push({
                property: 'ipiPercentage',
                header: 'ipi_percentage',
                widthInPoints: 70,
                isPercent: true
            })

            this.columns.forEach((column: GridColumn) => column.hideSorting = true)
        }

        onLoadMore(pageNumber: number, pageSize: number) {
            this.getAccountDetails({
                pathVariable: this.memberIdNum,
                requestorCallback: this,
                requestBody: {
                    pageNumber: pageNumber,
                    pageSize: 3
                }
            })
        }

        exportAccountDetailsGrid(exportType: ExportType, gridColumns: Array<GridColumn>): void {
            this.exportAccountDetails({
                requestBody: {
                    headerText: this.exportFileName,
                    exportType: exportType,
                    columnsList: gridColumns
                } as BaseRequest,
                pathVariable: this.memberIdNum,
                requestorCallback: this
            })
        }

        get exportFileName(): string {
            return '' + this.$t('policy_details_for_insured', {employeeIdNum: this.memberIdNum})
        }
    }
